module.exports = __webpack_public_path__ + "img/NemaSpp.cd657880.png";